import { render } from "./MHero.vue?vue&type=template&id=4ffc640a"
import script from "./MHero.vue?vue&type=script&lang=js"
export * from "./MHero.vue?vue&type=script&lang=js"

import "./MHero.vue?vue&type=style&index=0&id=4ffc640a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__